import type { YardiResidentMatch, YardiResidentRecord } from '../types/yardiResidentSync'

function libertyRecord(row: YardiResidentMatch): YardiResidentRecord {
  return (
    (row.liberty_matched_candidate as YardiResidentRecord | undefined) ??
    (row.liberty_main_candidate as YardiResidentRecord | undefined) ??
    row.liberty ??
    row.liberty_resident ??
    {}
  )
}

function yardiRecord(row: YardiResidentMatch): YardiResidentRecord {
  return (
    (row.source_matched_candidate as YardiResidentRecord | undefined) ??
    (row.source_main_candidate as YardiResidentRecord | undefined) ??
    row.yardi ??
    row.yardi_resident ??
    {}
  )
}

/** Angular `getYardiReviewKey` — checkbox / submit mapping identity. */
export function getYardiReviewSelectionKey(row: YardiResidentMatch): string {
  const yardi = yardiRecord(row)
  const liberty = libertyRecord(row)
  const resident = (row.resident ?? {}) as YardiResidentRecord
  return [
    row.liberty_entity_id ??
      liberty.resident_default_id ??
      liberty.applicant_id ??
      liberty.user_email ??
      '',
    row.source_entity_id ??
      row.resident_tcode ??
      yardi.sourceEntityId ??
      yardi.tCode ??
      resident.tCode ??
      '',
    row.source_candidate_type ?? row.decision ?? row.status ?? '',
  ].join('__')
}

/** Unique per list row so shared selection keys expand one-at-a-time (Angular object-identity). */
export function getYardiReviewExpandKey(row: YardiResidentMatch, index: number): string {
  return `${getYardiReviewSelectionKey(row)}__idx${index}`
}

export function isYardiReviewRowExpanded(
  expandedKey: string | null,
  row: YardiResidentMatch,
  index: number,
): boolean {
  return expandedKey != null && expandedKey === getYardiReviewExpandKey(row, index)
}

export function nextYardiReviewExpandedKey(
  currentExpandedKey: string | null,
  row: YardiResidentMatch,
  index: number,
): string | null {
  const key = getYardiReviewExpandKey(row, index)
  return currentExpandedKey === key ? null : key
}
